export default __webpack_public_path__ + "static/media/j43.72dfb3d7.jpg";